import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AuctionWithItems } from '../types';

interface AuctionContextType {
  currentAuction: AuctionWithItems | null;
  setCurrentAuction: (auction: AuctionWithItems | null) => void;
}

const AuctionContext = createContext<AuctionContextType | undefined>(undefined);

export function AuctionProvider({ children }: { children: ReactNode }) {
  const [currentAuction, setCurrentAuction] = useState<AuctionWithItems | null>(null);

  return (
    <AuctionContext.Provider value={{ currentAuction, setCurrentAuction }}>
      {children}
    </AuctionContext.Provider>
  );
}

export function useAuctionContext() {
  const context = useContext(AuctionContext);
  if (context === undefined) {
    throw new Error('useAuctionContext must be used within an AuctionProvider');
  }
  return context;
}
